import React, { useEffect, useState, useRef } from "react";
import { Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useLazyGetMeQuery } from "../../api/apiSlice";
import { setCredentials, logOut } from "../../features/auth/authSlice";
import Loading from "../common/Loading";

const PersistLogin = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [getMe] = useLazyGetMeQuery();
  const { user, token } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const effectRan = useRef(false);

  useEffect(() => {
    if (effectRan.current === true || process.env.NODE_ENV !== "development") {
      const verifySession = async () => {
        try {
          if (token && user) {
            // Если есть access-токен — пробуем /me. Если он истёк, baseQuery
            // в apiSlice автоматически дёрнет /auth/refresh с httpOnly cookie.
            await getMe().unwrap();
          } else {
            // Access-токена нет, но cookie с refresh-токеном может быть.
            // Пробуем /refresh — браузер пошлёт cookie благодаря credentials:'include'.
            const res = await fetch(
              `${process.env.REACT_APP_API_URL || "http://localhost:5000/api"}/auth/refresh`,
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({}),
              }
            );
            if (res.ok) {
              const data = await res.json();
              dispatch(setCredentials({ user: data.user, accessToken: data.accessToken }));
            } else {
              // Нет валидной сессии — это нормальный кейс «не залогинен».
              // Тихо чистим стейт без error-логов.
              dispatch(logOut());
            }
          }
        } catch (err) {
          console.error("Session restore failed:", err);
          dispatch(logOut());
        } finally {
          setIsLoading(false);
        }
      };

      verifySession();
    }
    return () => {
      effectRan.current = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-slate-50 dark:bg-slate-900">
        <Loading variant="block" size="lg" />
      </div>
    );
  }

  return <Outlet />;
};

export default PersistLogin;
